import React from 'react';
import { TrustpilotStars } from './StarRating';

const RelatedCompanies = ({ companies = [], onCompanyClick }) => {
  const handleClick = (company) => {
    if (onCompanyClick) {
      onCompanyClick(company.domain);
    }
  };

  return (
    <div className="bg-white rounded-lg border p-6 mt-6">
      <h3 className="font-semibold text-[#1a1a1a] mb-4">Les gens ont aussi consulté</h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {companies.map((company) => (
          <button
            key={company.id}
            onClick={() => handleClick(company)}
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors group text-left w-full"
          >
            {/* Company Avatar */}
            <div className="w-12 h-12 rounded-full bg-[#00b67a] flex items-center justify-center text-white font-bold text-lg flex-shrink-0">
              {company.name.charAt(0)}
            </div>
            
            <div className="min-w-0 flex-1">
              <p className="font-medium text-[#1a1a1a] truncate group-hover:underline">
                {company.name}
              </p>
              <p className="text-xs text-gray-500 truncate">{company.domain}</p>
              <div className="flex items-center gap-2 mt-1">
                <TrustpilotStars rating={company.stats?.trust_score || 0} size="xs" />
                <span className="text-sm font-medium text-[#1a1a1a]">
                  {company.stats?.trust_score || 0}
                </span>
                <span className="text-xs text-gray-500">
                  ({company.stats?.total_reviews || 0})
                </span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RelatedCompanies;
